module.exports = __webpack_public_path__ + "img/bakery.8e11f3ab.svg";